var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReturn = function SvgReturn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.604 4.183a.625.625 0 1 1 .884.884L6.133 8.422h8.809a5.82 5.82 0 1 1 0 11.641h-4.38a.625.625 0 0 1 0-1.25h4.38a4.57 4.57 0 0 0 0-9.14H6.134l3.354 3.354a.625.625 0 1 1-.884.884L4.183 9.489a.625.625 0 0 1 0-.884l4.42-4.422Z",
    fill: "#151A22",
    fillOpacity: 0.16
  })));
};
export default SvgReturn;